export enum Locale {
    EN = 'en',
    RO = 'ro'
}

export const defaultLocale = Locale.EN;